import { useQuery } from "@tanstack/react-query";
import { from, unwrap } from "@vixio/data";
import { monthStartIso, todayIso } from "@vixio/ui";

/** Dados dos painéis do Início: ficam fora da tela para que ela carregue sob demanda. */
export interface Monthly {
  issuer_id: string | null;
  month: string;
  contracted_cents: number;
  invoiced_cents: number;
  received_cents: number;
}

export interface Target {
  month: string;
  received_cents: number;
  target_income_cents: number | null;
  required_revenue_cents: number | null;
  gap_cents: number | null;
  pct_of_required: number | null;
  implied_income_cents: number | null;
  margin_pct: number | null;
}

export function useRevenueMonthly(orgId: string) {
  return useQuery({
    queryKey: ["revenue", "v_monthly", orgId],
    queryFn: async () => {
      const rows = await unwrap<Monthly[]>(from("revenue", "v_monthly").select("*").eq("org_id", orgId).order("month").limit(2000));
      const map = new Map<string, Monthly>();
      for (const r of rows) {
        const m = map.get(r.month) ?? { issuer_id: null, month: r.month, contracted_cents: 0, invoiced_cents: 0, received_cents: 0 };
        m.contracted_cents += Number(r.contracted_cents);
        m.invoiced_cents += Number(r.invoiced_cents);
        m.received_cents += Number(r.received_cents);
        map.set(r.month, m);
      }
      return [...map.values()].sort((a, b) => a.month.localeCompare(b.month));
    },
  });
}

export function useFounderTarget(orgId: string) {
  return useQuery({
    queryKey: ["revenue", "v_founder_target", orgId],
    queryFn: async () =>
      (await unwrap<Target[]>(from("revenue", "v_founder_target").select("*").eq("org_id", orgId).eq("month", monthStartIso(todayIso())).limit(1)))[0] ?? null,
  });
}
